import React from "react";
import { CircularProgress } from "@material-ui/core";

function LoadingComponent() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
      <div style={{ marginTop: 20 }}>Carregando...</div>
    </div>
  );
}

export default LoadingComponent;
